module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-33-e7335f29ccebfe548a79d81e15f9af76.jpg";